export const GET_AGENCY = "GET_AGENCY";

export const CREATE_NEW_AGENCY = "CREATE_NEW_AGENCY";
export const SET_CREATE_AGENCY_DONE = "SET_CREATE_AGENCY_DONE";
export const UNSET_CREATE_AGENCY_DONE = "UNSET_CREATE_AGENCY_DONE";
export const SET_UPDATE_AGENCY_DONE = "SET_UPDATE_AGENCY_DONE";
export const UNSET_UPDATE_AGENCY_DONE = "UNSET_UPDATE_AGENCY_DONE";

export const OPEN_AGENCY_DIALOG = "OPEN_AGENCY_DIALOG";
export const CLOSE_AGENCY_DIALOG = "CLOSE_AGENCY_DIALOG";

export const EDIT_AGENCY = "EDIT_AGENCY";

export const ENABLE_DISABLE_AGENCY = "ENABLE_DISABLE_AGENCY";


export const GET_AGENCY_DROPDOWN = "GET_AGENCY_DROPDOWN"
